/**
 * Bank Reference Database
 * Comprehensive list of banks with FI IDs for OFX/QBO export
 * Includes major banks from US, UK, AU, CA, NZ, IE, SG, NG, KE, ZA
 */

export const BANKS = [
  // === UNITED STATES ===
  {
    name: 'Bank of America',
    fiId: '5959',
    routing: '026009593',
    swift: 'BOFAUS3N',
    country: 'US',
    currency: 'USD'
  },
  {
    name: 'Chase Bank (JPMorgan Chase)',
    fiId: '1001',
    routing: '021000021',
    swift: 'CHASUS33',
    country: 'US',
    currency: 'USD'
  },
  {
    name: 'Wells Fargo',
    fiId: '3000',
    routing: '121000248',
    swift: 'WFBIUS6S',
    country: 'US',
    currency: 'USD'
  },
  {
    name: 'Citibank',
    fiId: '24909',
    routing: '021000089',
    swift: 'CITIUS33',
    country: 'US',
    currency: 'USD'
  },
  {
    name: 'U.S. Bank',
    fiId: '1402',
    routing: '091000022',
    swift: 'USBKUS44',
    country: 'US',
    currency: 'USD'
  },
  {
    name: 'PNC Bank',
    fiId: '4501',
    routing: '041000124',
    swift: 'PNCCUS33',
    country: 'US',
    currency: 'USD'
  },
  {
    name: 'Capital One',
    fiId: '12573',
    routing: '065000090',
    swift: 'NFBKUS33',
    country: 'US',
    currency: 'USD'
  },
  {
    name: 'BNY Mellon',
    fiId: '2801',
    routing: '021000018',
    swift: 'IRVTUS3N',
    country: 'US',
    currency: 'USD'
  },

  // === UNITED KINGDOM ===
  {
    name: 'HSBC UK',
    fiId: 'HBUK',
    sortCode: '40-02-50',
    swift: 'HBUKGB4B',
    country: 'GB',
    currency: 'GBP'
  },
  {
    name: 'Lloyds Bank',
    fiId: 'LLOY',
    sortCode: '30-00-00',
    swift: 'LOYDGB21',
    country: 'GB',
    currency: 'GBP'
  },
  {
    name: 'Barclays',
    fiId: 'BARC',
    sortCode: '20-00-00',
    swift: 'BARCGB22',
    country: 'GB',
    currency: 'GBP'
  },
  {
    name: 'NatWest',
    fiId: 'NATW',
    sortCode: '60-00-01',
    swift: 'NWBKGB2L',
    country: 'GB',
    currency: 'GBP'
  },
  {
    name: 'Santander UK',
    fiId: 'SANT',
    sortCode: '09-01-28',
    swift: 'ABBYGB2L',
    country: 'GB',
    currency: 'GBP'
  },
  {
    name: 'TSB Bank',
    fiId: 'TSBK',
    sortCode: '77-70-00',
    swift: 'TSBSGB2A',
    country: 'GB',
    currency: 'GBP'
  },
  {
    name: 'Metro Bank',
    fiId: 'METR',
    sortCode: '23-05-80',
    swift: 'MYMGGB2L',
    country: 'GB',
    currency: 'GBP'
  },

  // === AUSTRALIA ===
  {
    name: 'Commonwealth Bank of Australia',
    fiId: 'CBA',
    bsb: '062-000',
    swift: 'CTBAAU2S',
    country: 'AU',
    currency: 'AUD'
  },
  {
    name: 'ANZ Bank',
    fiId: 'ANZ',
    bsb: '013-006',
    swift: 'ANZBAU3M',
    country: 'AU',
    currency: 'AUD'
  },
  {
    name: 'Westpac',
    fiId: 'WPAC',
    bsb: '032-000',
    swift: 'WPACAU2S',
    country: 'AU',
    currency: 'AUD'
  },
  {
    name: 'National Australia Bank (NAB)',
    fiId: 'NAB',
    bsb: '082-000',
    swift: 'NATAAU33',
    country: 'AU',
    currency: 'AUD'
  },
  {
    name: 'Bank of Queensland',
    fiId: 'BOQ',
    bsb: '124-001',
    swift: 'BQLQAU4B',
    country: 'AU',
    currency: 'AUD'
  },
  {
    name: 'Bendigo Bank',
    fiId: 'BEND',
    bsb: '633-000',
    swift: 'BENDAU3B',
    country: 'AU',
    currency: 'AUD'
  },
  {
    name: 'ING Australia',
    fiId: 'ING',
    bsb: '923-100',
    swift: 'INGBAU2S',
    country: 'AU',
    currency: 'AUD'
  },

  // === CANADA ===
  {
    name: 'Royal Bank of Canada (RBC)',
    fiId: 'RBC',
    transitNumber: '00003',
    swift: 'ROYCCAT2',
    country: 'CA',
    currency: 'CAD'
  },
  {
    name: 'TD Canada Trust',
    fiId: 'TD',
    transitNumber: '00004',
    swift: 'TDOMCATTTOR',
    country: 'CA',
    currency: 'CAD'
  },
  {
    name: 'Scotiabank',
    fiId: 'BNS',
    transitNumber: '00002',
    swift: 'NOSCCATT',
    country: 'CA',
    currency: 'CAD'
  },
  {
    name: 'Bank of Montreal (BMO)',
    fiId: 'BMO',
    transitNumber: '00001',
    swift: 'BOFMCAT2',
    country: 'CA',
    currency: 'CAD'
  },
  {
    name: 'CIBC',
    fiId: 'CIBC',
    transitNumber: '00010',
    swift: 'CIBCCATT',
    country: 'CA',
    currency: 'CAD'
  },
  {
    name: 'National Bank of Canada',
    fiId: 'NBC',
    transitNumber: '00006',
    swift: 'BNDCCAMMINT',
    country: 'CA',
    currency: 'CAD'
  },

  // === NEW ZEALAND ===
  {
    name: 'ANZ Bank New Zealand',
    fiId: 'ANZNZ',
    bankCode: '01',
    swift: 'ANZBNZ22',
    country: 'NZ',
    currency: 'NZD'
  },
  {
    name: 'ASB Bank',
    fiId: 'ASB',
    bankCode: '12',
    swift: 'ASBBNZ2A',
    country: 'NZ',
    currency: 'NZD'
  },
  {
    name: 'Bank of New Zealand (BNZ)',
    fiId: 'BNZ',
    bankCode: '02',
    swift: 'BKNZNZ22',
    country: 'NZ',
    currency: 'NZD'
  },
  {
    name: 'Westpac New Zealand',
    fiId: 'WPACNZ',
    bankCode: '03',
    swift: 'WPACNZ2W',
    country: 'NZ',
    currency: 'NZD'
  },
  {
    name: 'Kiwibank',
    fiId: 'KIWI',
    bankCode: '38',
    swift: 'KIWINZ22',
    country: 'NZ',
    currency: 'NZD'
  },
  {
    name: 'TSB Bank (NZ)',
    fiId: 'TSBNZ',
    bankCode: '15',
    swift: 'TSBANZ22',
    country: 'NZ',
    currency: 'NZD'
  },

  // === IRELAND ===
  {
    name: 'AIB (Allied Irish Banks)',
    fiId: 'AIB',
    nsc: '93-10-36',
    swift: 'AIBKIE2D',
    country: 'IE',
    currency: 'EUR'
  },
  {
    name: 'Bank of Ireland',
    fiId: 'BOI',
    nsc: '90-00-17',
    swift: 'BOFIIE2D',
    country: 'IE',
    currency: 'EUR'
  },
  {
    name: 'Ulster Bank',
    fiId: 'ULST',
    nsc: '98-50-00',
    swift: 'ULSBIE2D',
    country: 'IE',
    currency: 'EUR'
  },
  {
    name: 'Permanent TSB',
    fiId: 'PTSB',
    nsc: '99-01-80',
    swift: 'IPBSIE2D',
    country: 'IE',
    currency: 'EUR'
  },
  {
    name: 'KBC Bank Ireland',
    fiId: 'KBC',
    nsc: '93-30-10',
    swift: 'KREDIE2D',
    country: 'IE',
    currency: 'EUR'
  },

  // === SINGAPORE ===
  {
    name: 'DBS Bank',
    fiId: 'DBS',
    bankCode: '7171',
    swift: 'DBSSSGSG',
    country: 'SG',
    currency: 'SGD'
  },
  {
    name: 'OCBC Bank',
    fiId: 'OCBC',
    bankCode: '7339',
    swift: 'OCBCSGSG',
    country: 'SG',
    currency: 'SGD'
  },
  {
    name: 'UOB (United Overseas Bank)',
    fiId: 'UOB',
    bankCode: '7375',
    swift: 'UOVBSGSG',
    country: 'SG',
    currency: 'SGD'
  },
  {
    name: 'Maybank Singapore',
    fiId: 'MAYB',
    bankCode: '7302',
    swift: 'MBBESGSG',
    country: 'SG',
    currency: 'SGD'
  },
  {
    name: 'Standard Chartered Singapore',
    fiId: 'SC',
    bankCode: '7144',
    swift: 'SCBLSG22',
    country: 'SG',
    currency: 'SGD'
  },
  {
    name: 'CIMB Bank',
    fiId: 'CIMB',
    bankCode: '7214',
    swift: 'CIBBSGSG',
    country: 'SG',
    currency: 'SGD'
  },

  // === NIGERIA ===
  {
    name: 'First Bank of Nigeria',
    fiId: 'FBN',
    sortCode: '011',
    swift: 'FBNINGLA',
    country: 'NG',
    currency: 'NGN'
  },
  {
    name: 'Access Bank',
    fiId: 'ACCESS',
    sortCode: '044',
    swift: 'ABNGNGLA',
    country: 'NG',
    currency: 'NGN'
  },
  {
    name: 'Zenith Bank',
    fiId: 'ZENITH',
    sortCode: '057',
    swift: 'ZEIBNGLA',
    country: 'NG',
    currency: 'NGN'
  },
  {
    name: 'Guaranty Trust Bank (GTBank)',
    fiId: 'GTB',
    sortCode: '058',
    swift: 'GTBINGLA',
    country: 'NG',
    currency: 'NGN'
  },
  {
    name: 'United Bank for Africa (UBA)',
    fiId: 'UBA',
    sortCode: '033',
    swift: 'UNAFNGLA',
    country: 'NG',
    currency: 'NGN'
  },
  {
    name: 'Fidelity Bank',
    fiId: 'FIDEL',
    sortCode: '070',
    swift: 'FIDTNGLA',
    country: 'NG',
    currency: 'NGN'
  },
  {
    name: 'Sterling Bank',
    fiId: 'STERL',
    sortCode: '232',
    swift: 'NAMGNGLA',
    country: 'NG',
    currency: 'NGN'
  },
  {
    name: 'Stanbic IBTC Bank',
    fiId: 'STAN',
    sortCode: '221',
    swift: 'SBICNGLA',
    country: 'NG',
    currency: 'NGN'
  },
  {
    name: 'Union Bank of Nigeria',
    fiId: 'UNION',
    sortCode: '032',
    swift: 'UBNINGLA',
    country: 'NG',
    currency: 'NGN'
  },
  {
    name: 'Wema Bank',
    fiId: 'WEMA',
    sortCode: '035',
    swift: 'WEMANGLA',
    country: 'NG',
    currency: 'NGN'
  },
  {
    name: 'Polaris Bank',
    fiId: 'POLAR',
    sortCode: '076',
    swift: 'SKYELAGX',
    country: 'NG',
    currency: 'NGN'
  },
  {
    name: 'Unity Bank',
    fiId: 'UNITY',
    sortCode: '215',
    swift: 'UNIYINGLA',
    country: 'NG',
    currency: 'NGN'
  },
  {
    name: 'Keystone Bank',
    fiId: 'KEY',
    sortCode: '082',
    swift: 'KBSLNGLA',
    country: 'NG',
    currency: 'NGN'
  },
  {
    name: 'Heritage Bank',
    fiId: 'HERIT',
    sortCode: '030',
    swift: 'HBCLNGLA',
    country: 'NG',
    currency: 'NGN'
  },
  {
    name: 'Providus Bank',
    fiId: 'PROV',
    sortCode: '101',
    swift: 'PRVSNGLA',
    country: 'NG',
    currency: 'NGN'
  },

  // === KENYA ===
  {
    name: 'Kenya Commercial Bank (KCB)',
    fiId: 'KCB',
    bankCode: '01',
    swift: 'KCBLKENX',
    country: 'KE',
    currency: 'KES'
  },
  {
    name: 'Equity Bank',
    fiId: 'EQUITY',
    bankCode: '68',
    swift: 'EQBLKENA',
    country: 'KE',
    currency: 'KES'
  },
  {
    name: 'Cooperative Bank of Kenya',
    fiId: 'COOP',
    bankCode: '11',
    swift: 'KCOOKENA',
    country: 'KE',
    currency: 'KES'
  },
  {
    name: 'Standard Chartered Kenya',
    fiId: 'SCK',
    bankCode: '02',
    swift: 'SCBLKENX',
    country: 'KE',
    currency: 'KES'
  },
  {
    name: 'Absa Bank Kenya',
    fiId: 'ABSA',
    bankCode: '03',
    swift: 'BARCKENX',
    country: 'KE',
    currency: 'KES'
  },
  {
    name: 'Diamond Trust Bank (DTB)',
    fiId: 'DTB',
    bankCode: '63',
    swift: 'DTKEKENA',
    country: 'KE',
    currency: 'KES'
  },
  {
    name: 'I&M Bank',
    fiId: 'IM',
    bankCode: '57',
    swift: 'IMBLKENA',
    country: 'KE',
    currency: 'KES'
  },
  {
    name: 'National Bank of Kenya',
    fiId: 'NBK',
    bankCode: '12',
    swift: 'NBKEKENX',
    country: 'KE',
    currency: 'KES'
  },
  {
    name: 'Commercial Bank of Africa (CBA)',
    fiId: 'CBA',
    bankCode: '66',
    swift: 'CBAFKENX',
    country: 'KE',
    currency: 'KES'
  },
  {
    name: 'Family Bank',
    fiId: 'FAMILY',
    bankCode: '70',
    swift: 'FAMIKENX',
    country: 'KE',
    currency: 'KES'
  },
  {
    name: 'Prime Bank',
    fiId: 'PRIME',
    bankCode: '10',
    swift: 'PRKEKENX',
    country: 'KE',
    currency: 'KES'
  },
  {
    name: 'Gulf African Bank',
    fiId: 'GULF',
    bankCode: '72',
    swift: 'GULAKEAX',
    country: 'KE',
    currency: 'KES'
  },
  {
    name: 'Sidian Bank',
    fiId: 'SIDIAN',
    bankCode: '66',
    swift: 'KBAUKENX',
    country: 'KE',
    currency: 'KES'
  },
  {
    name: 'Bank of Baroda Kenya',
    fiId: 'BOB',
    bankCode: '06',
    swift: 'BARBKENX',
    country: 'KE',
    currency: 'KES'
  },
  {
    name: 'HFC Limited',
    fiId: 'HFC',
    bankCode: '61',
    swift: 'HFCOKEAX',
    country: 'KE',
    currency: 'KES'
  },

  // === SOUTH AFRICA ===
  {
    name: 'ABSA Bank',
    fiId: 'ABSA',
    branchCode: '632005',
    swift: 'ABSAZAJJ',
    country: 'ZA',
    currency: 'ZAR'
  },
  {
    name: 'First National Bank (FNB)',
    fiId: 'FNB',
    branchCode: '250655',
    swift: 'FIRNZAJJ',
    country: 'ZA',
    currency: 'ZAR'
  },
  {
    name: 'Standard Bank',
    fiId: 'STND',
    branchCode: '051001',
    swift: 'SBZAZAJJ',
    country: 'ZA',
    currency: 'ZAR'
  },
  {
    name: 'Nedbank',
    fiId: 'NED',
    branchCode: '198765',
    swift: 'NEDSZAJJ',
    country: 'ZA',
    currency: 'ZAR'
  },
  {
    name: 'Capitec Bank',
    fiId: 'CAPITEC',
    branchCode: '470010',
    swift: 'CABLZAJJ',
    country: 'ZA',
    currency: 'ZAR'
  },
  {
    name: 'Investec Bank',
    fiId: 'INVEST',
    branchCode: '580105',
    swift: 'IVESZAJJ',
    country: 'ZA',
    currency: 'ZAR'
  },
  {
    name: 'African Bank',
    fiId: 'AFRIC',
    branchCode: '430000',
    swift: 'AFRCZAJJ',
    country: 'ZA',
    currency: 'ZAR'
  },
  {
    name: 'Discovery Bank',
    fiId: 'DISC',
    branchCode: '679000',
    swift: 'DICSZAJJ',
    country: 'ZA',
    currency: 'ZAR'
  },
  {
    name: 'TymeBank',
    fiId: 'TYME',
    branchCode: '678910',
    swift: 'TYMEZAJJ',
    country: 'ZA',
    currency: 'ZAR'
  },
  {
    name: 'Bidvest Bank',
    fiId: 'BIDVEST',
    branchCode: '462005',
    swift: 'BIDBZAJJ',
    country: 'ZA',
    currency: 'ZAR'
  }
];

/**
 * Currency Reference
 * Maps currency codes to symbols and display names
 */
export const CURRENCIES = [
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'GBP', symbol: '£', name: 'British Pound' },
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'AUD', symbol: 'A$', name: 'Australian Dollar' },
  { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar' },
  { code: 'NZD', symbol: 'NZ$', name: 'New Zealand Dollar' },
  { code: 'SGD', symbol: 'S$', name: 'Singapore Dollar' },
  { code: 'NGN', symbol: '₦', name: 'Nigerian Naira' },
  { code: 'KES', symbol: 'KSh', name: 'Kenyan Shilling' },
  { code: 'ZAR', symbol: 'R', name: 'South African Rand' }
];

/**
 * OFX Account Types
 * Standard account types for OFX format
 */
export const ACCOUNT_TYPES_OFX = [
  { value: 'CHECKING', label: 'Checking Account' },
  { value: 'SAVINGS', label: 'Savings Account' },
  { value: 'CREDITLINE', label: 'Credit Line' },
  { value: 'MONEYMRKT', label: 'Money Market' },
  { value: 'CREDITCARD', label: 'Credit Card' }
];

/**
 * QBO Account Types
 * Standard account types for QuickBooks
 */
export const ACCOUNT_TYPES_QBO = [
  { value: 'Bank', label: 'Bank Account' },
  { value: 'Credit Card', label: 'Credit Card' },
  { value: 'Other Current Asset', label: 'Other Current Asset' }
];

/**
 * Helper function to search banks
 * @param {string} searchTerm - The search term
 * @returns {Array} Filtered banks matching the search term
 */
export function searchBanks(searchTerm) {
  if (!searchTerm || searchTerm.trim() === '') {
    return BANKS;
  }

  const lowerSearch = searchTerm.toLowerCase();
  return BANKS.filter(bank =>
    bank.name.toLowerCase().includes(lowerSearch) ||
    bank.country.toLowerCase().includes(lowerSearch) ||
    bank.fiId.toLowerCase().includes(lowerSearch)
  );
}

/**
 * Helper function to get banks by country
 * @param {string} countryCode - Two-letter country code
 * @returns {Array} Banks from the specified country
 */
export function getBanksByCountry(countryCode) {
  return BANKS.filter(bank => bank.country === countryCode);
}

/**
 * Helper function to get currency info
 * @param {string} currencyCode - Three-letter currency code
 * @returns {Object|null} Currency info or null if not found
 */
export function getCurrencyInfo(currencyCode) {
  return CURRENCIES.find(curr => curr.code === currencyCode) || null;
}

/**
 * Get unique list of countries from bank data
 * @returns {Array} Array of country objects with code and name
 */
export function getCountries() {
  const countryMap = {
    'US': 'United States',
    'GB': 'United Kingdom',
    'AU': 'Australia',
    'CA': 'Canada',
    'NZ': 'New Zealand',
    'IE': 'Ireland',
    'SG': 'Singapore',
    'NG': 'Nigeria',
    'KE': 'Kenya',
    'ZA': 'South Africa'
  };

  const uniqueCountries = [...new Set(BANKS.map(bank => bank.country))];
  return uniqueCountries.map(code => ({
    code,
    name: countryMap[code] || code
  }));
}
